import {AsyncActionState} from '../asyncUtilsTypes';
import {requestVeevaDocMetadata, requestVeevaMdpList, requestVeevaMdpModelLanguage, requestVeevaVeap} from './api';
import {VeevaAction, VeevaActions} from './types';
import {reduceAsyncAction} from '../asyncUtils';
import {Await} from '../types';

export type VeevaState = {
  veaps: {
    [key: string]: AsyncActionState<Await<ReturnType<typeof requestVeevaVeap>>, Parameters<typeof requestVeevaVeap>>;
  };
  mdps: {
    [key: string]: AsyncActionState<
      Await<ReturnType<typeof requestVeevaMdpList>>,
      Parameters<typeof requestVeevaMdpList>
    >;
  };
  modelLanguages: {
    [key: string]: AsyncActionState<
      Await<ReturnType<typeof requestVeevaMdpModelLanguage>>,
      Parameters<typeof requestVeevaMdpModelLanguage>
    >;
  };
  docMetadatas: {
    [key: string]: AsyncActionState<
      Await<ReturnType<typeof requestVeevaDocMetadata>>,
      Parameters<typeof requestVeevaDocMetadata>
    >;
  };
};

export const veevaInitialState = {
  veaps: {},
  mdps: {},
  modelLanguages: {},
  docMetadatas: {},
};

export const veevaReducer = (state = veevaInitialState, action: VeevaAction): VeevaState => {
  switch (action.type) {
    case VeevaActions.REQUEST_VEAP: {
      const [searchedTerm] = action.params;
      return {
        ...state,
        veaps: {
          ...state.veaps,
          [searchedTerm]: reduceAsyncAction(action),
        },
      };
    }

    case VeevaActions.REQUEST_MDP_LIST: {
      const [searchedTerm] = action.params;
      return {
        ...state,
        mdps: {
          ...state.mdps,
          [searchedTerm]: reduceAsyncAction(action),
        },
      };
    }

    case VeevaActions.REQUEST_MDP_MODEL_LANGUAGE: {
      const [mdpUrl] = action.params;
      return {
        ...state,
        modelLanguages: {
          ...state.modelLanguages,
          [mdpUrl]: reduceAsyncAction(action),
        },
      };
    }

    case VeevaActions.REQUEST_DOC_METADATA: {
      const [veapId] = action.params;
      return {
        ...state,
        docMetadatas: {
          ...state.docMetadatas,
          [veapId]: reduceAsyncAction(action),
        },
      };
    }
  }
  return state;
};
